import React, { useEffect, useRef, useState } from 'react';
import '../Assets/CSS/Product.css';
import "react-toastify/dist/ReactToastify.css";
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import ContactUs from '../sections/home/Contactus';
import ReviewModal from '../components/ReviewModal';
import axios from 'axios';
import { set } from 'react-hook-form';
import toast, { Toaster } from 'react-hot-toast';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'
import { getCookie } from '../components/auth/login/GetCookie';
import { useLocationContext } from '../context/LocationContext';
// Import a close icon from lucide-react or any other icon library


const ProductDetailPage = () => {
    const Navigate = useNavigate();
     const { address } = useLocationContext(); // 👈 get Maharashtra, India
    // Get sellerId from URL
    const { id } = useParams();
    const [enquiry, setEnquiry] = useState({
        productId: id,
        productEnquiryMsg: '',

    });
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [productDetail, setProductDetail] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false); // State to manage modal visibility
    const [reviews, setReviews] = useState([]);
    // const [refresh, setRefresh] = useState(0);
    // State to store reviews data
    const [error, setError] = useState(null);
    const handleOpenModal = () => {
        setIsModalOpen(true); // Open the modal
    };

    const handleCloseModal = () => {
        setIsModalOpen(false); // Close the modal
    };
    

    useEffect(() => {
        fetchReviews();


  
      fetchProductDetail(); // only when address is ready
    
    }, [showModal,address]);
    // Handle review submission
    


    const handleReviewSubmit = (review) => {
        console.log("Submitted Review:", review);
        // You can send this data to an API endpoint here
    };
    const fetchProductDetail = async () => {
        //const token = localStorage.getItem('token'); // Retrieve token from localStorage
        const token = getCookie("token");
        try {
                // const locationHeader = address || " ";
                const locationHeader = address ? address : ""; // send blank string if address is not available

            //   const locationHeader = location ? JSON.stringify(location) : "";
              console.log("Passing location of user to header",locationHeader);
            await new Promise(res => setTimeout(res, 2000));
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/user/products/${id}`, {
                headers: {
                    'Accept': '*/*',
                    'Authorization': `Bearer ${token}`, // Include Bearer token
                    "X-User-Location": locationHeader, // <-- pass location here
                    
                },
            });

            // Set product detail from the response
            setProductDetail(response.data);
            console.log("Single Product: ",response.data)
            console.log(response.data);
        } catch (error) {
            toast.error("Error: You are not authorized to access this page.");
            console.error('Error fetching product details:', error);
        }
    };

    const enquiryData = async () => {
        // const token = localStorage.getItem('token');
        const token = getCookie("token");
        setIsLoading(true); // Show loader
        console.log("----",enquiry); // To check the data being sent

        const requestPayload = {
            productEnquiryMsg: enquiry.productEnquiryMsg,
        };

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/product-enquiries/${id}`,
                requestPayload, // Send the structured data
                {
                    headers: {
                        'Accept': '*/*',
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json', // Set Content-Type
                    },
                }
            );
            if(response.status===200)
            {
            toast.success("Enquiry sent successfully");
            setEnquiry("");
            handleCloseModal();
            console.log(response.data);
            }

            
        } catch (error) {
            toast.error("Error: You are not authorized to access this page.");
            handleCloseModal();
            console.error('Error fetching product details:', error.response || error.message);
        } finally {
            setIsLoading(false); // Hide loader
        }
    };

    const fetchReviews = async () => {
        try {
            setIsLoading(true); // Set loading state to true when fetching
            //const token = localStorage.getItem('token'); // Get token from localStorage
            const token = getCookie("token");
            await new Promise(res => setTimeout(res, 2000));
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/product-reviews/${id}`, // Your API endpoint
                {
                    headers: {
                        'Authorization': `Bearer ${token}`, // Send the token for authorization
                        'Accept': '*/*', // Accept JSON response
                    },
                }
            );

            // Ensure response and response.data are not undefined
            if (response && response.data) {
                setReviews(response.data); // Store the fetched reviews in state
                console.log(response.data);
            } else {
                throw new Error("Invalid response from server");
            }
        } catch (error) {
            console.error('Error fetching reviews:', error);

            // Ensure error object has response before accessing status
            if (error.response) {
                console.error("API Error Status:", error.response.status);
                toast.error(`Failed to fetch reviews: ${error.response.status}`);
            } else {
                toast.error("Failed to fetch reviews: Network or Server Error");
            }
        } finally {
            setIsLoading(false); // Set loading state to false once the fetch is done
        }
    };

    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
        if (tabName === 'company') {
            Navigate(`/companydetail/${productDetail.sellerId}`); // Navigate to the company detail page
        }
    };
    const [activeTab, setActiveTab] = useState('general');
    const [activeIndex, setActiveIndex] = useState(0);
    // const Images = [ProDet1, ProDet2, ProDet3, ProDet4, ProDet4];
    // Reference for the Swiper instance
    const swiperRef = useRef(null);
    const calculateAverageRating = (reviews) => {
        if (reviews.length === 0) return 0;
        const totalRating = reviews.reduce((acc, review) => acc + review.rating, 0);
        return (totalRating / reviews.length).toFixed(1); // Round to 1 decimal place
    };

    const navigate = useNavigate();
    const averageRating = calculateAverageRating(reviews);
    const handleImageClick = (index) => {
        setActiveIndex(index);
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.slideTo(index);  // Change the swiper slide programmatically
        }
    };
    return (
        <div>
            <div className='container mt-5'>
            <Toaster position='top-right' reverseOrder={false}/>
           <div className='d-flex'>
           <div className='Link-Product' onClick={() => navigate("/")} style={{ cursor: 'pointer' }}>
            <Link to='/' className='text-decoration-none '>
                <Icon icon="iconamoon:home-thin" className='fs-3 pb-1 ' style={{ color: '#5E6B49' }} />
            </Link>
            </div>
            <div className='Link-Product' onClick={() => navigate(-1)} style={{ cursor: 'pointer' }}>
            <Link to='#' className='text-decoration-none' style={{ color: '#5E6B49' }}>
                <Icon icon="weui:arrow-outlined" className='fs-4 me-1' />
                {isLoading ? <Skeleton width={150} /> : productDetail.productCategoryNames}
            </Link>
            </div>
           </div>

                <div className='row mt-3 d-flex flex-wrap gap-1'>

                    <div className="container">
                        <div className="row">
                            {/* Sidebar Thumbnails */}
                            <div className="col-lg-1 col-md-2 col-12">
                                <div className="Product-Detail-Image-List ">
                                {isLoading
      ? Array.from({ length: 4 }).map((_, index) => (
          <Skeleton
            key={index}
            height={75}
            width={'100%'}
            style={{ marginBottom: '8px', borderRadius: '8px' }}
          />
        )):
                                    productDetail?.productImageUrls?.map((imageUrl, index) => (
                                        <img
                                            key={index}
                                            src={imageUrl}
                                            alt={`Product-Image-${index}`}
                                            className="product-Images"
                                            onClick={() => handleImageClick(index)}
                                            style={{ cursor: 'pointer' }}
                                        />
                                    ))}
                                </div>
                            </div>



                            {/* Image Preview */}
                            <div className="col-lg-5 col-md-10 col-12">
                                <div className="Product-Detail-Image-Preview px-2">
                                {isLoading ? (
      <Skeleton
        height={400}
        width={'100%'}
        style={{ borderRadius: '20px' }}
      />
    ) : (
                                    <Swiper
                                        onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
                                        navigation={true}
                                        modules={[Navigation]}
                                        className="mySwiper"
                                        ref={swiperRef}
                                        initialSlide={activeIndex}
                                    >
                                        {productDetail?.productImageUrls?.map((imageUrl, index) => (
                                            <SwiperSlide key={index}>
                                                <img
                                                   src={imageUrl}
                                                    alt={`Product-Image-${index}`}
                                                    className="product-Images-preview"
                                                    style={{ borderRadius: '20px' }}
                                                />
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
    )}
                                </div>
                            </div>




                            {/* Product Details */}
                            <div className="col-lg-6 col-md-12 col-12">
                                <div className="Product-Detail-Info">
                                    <h1 className="productDetail-heading">{productDetail.productName}</h1>
                                    <div className='py-2'>
                                        <h5>General Description:</h5>
                                        <p className='tab-desc'>
                                        {isLoading ? <Skeleton width={550} height={20} count={3} /> :
                                            productDetail?.generalAttributes?.generalDescription}
                                        </p>

                                    </div>


                                    {/* Buttons */}
                                    <div className="product-btn-detail">
                                        <div className="d-flex flex-row gap-2 align-items-center justify-content-evenly flex-wrap">
                                            <button className="pro-btn "
                                                style={{
                                                    background: '#371300', color: 'white',
                                                    cursor: 'pointer',
                                                }}
                                                onClick={handleOpenModal} // Open modal on click
                                            >Get Quote</button>
                                            <button className="pro-btn" style={{color:'#371300'}} >Contact supplier</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* Tabs */}
                    <div className='product-Detail-tabs mt-5 mb-5'>
                        <h4 className='product-heading'>Product Details :</h4>
                        <ul className=' nav d-flex flex-nowrap '>
                            <li className='nav-item'>
                                <button
                                    className={`nav-link ${activeTab === 'general' ? 'active-tab' : ''}`}
                                    onClick={() => handleTabClick('general')}
                                >
                                    General Description
                                </button>
                            </li>
                            <li className='nav-item'>
                                <button
                                    className={`nav-link ${activeTab === 'technical' ? 'active-tab' : ''}`}
                                    onClick={() => handleTabClick('technical')}
                                >
                                    Technical Description
                                </button>
                            </li>
                            <li className='nav-item'>
                                <button
                                    className={`nav-link  ${activeTab === 'company' ? 'active-tab' : ''}`}
                                    onClick={() => handleTabClick('company')}
                                >
                                    About Company
                                </button>
                            </li>
                        </ul>

                        <div className='tab-content mt-3'>
                            {activeTab === 'general' && (
                                <div className='tab-pane fade show active'>
                                    <p className='tab-desc'>
                                    {isLoading ? <Skeleton width={550} height={20} count={3} /> :
                                        productDetail?.generalAttributes?.generalDescription}
                                    </p>
                                </div>
                            )}
                            {activeTab === 'technical' && (
                                <div className='tab-pane fade show active'>
                                    <p className='tab-desc'>
                                    {isLoading ? <Skeleton width={550} height={20} count={3} /> :
                                        productDetail.technicalAttributes.technicalDescription}
                                    </p>
                                    {id === 'technical' ? <div className='d-block'>

                                    </div> : null}
                                </div>
                            )}
                            {activeTab === 'company' && (
                                Navigate(`/companydetail/${productDetail.sellerId}`)

                            )}


                        </div>
                    </div>

                    {/* product characteristics */}
                    {activeTab === 'general' && (
                        <div className='product-characteristics mb-4 col-md-10 '>
                            <h1 className='CharcterHeading '> General Characteristics of Product</h1>
                            
                            {isLoading ? (
      <div className="mt-3">
        <Skeleton height={40} className="mb-2" />
        <Skeleton height={40} className="mb-2" />
        <Skeleton height={40} className="mb-2" />
        <Skeleton height={40} className="mb-2" />
      </div>
    ) : (
                            
                            <table className="table table-bordered mt-3">
                                <thead>
                                    <tr>
                                        <th className="table-head-points border-1 px-2 py-2"
                                        >Characteristics</th>
                                        <th className="table-head border-1 px-2 py-2">Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {productDetail?.generalAttributes &&
                                        Object.keys(productDetail.generalAttributes).length > 0 ? (
                                        Object.entries(productDetail.generalAttributes)
                                            .filter(([key]) => key !== "generalDescription")
                                            .map(([key, value], index) => (
                                                <tr key={index}>
                                                    <td className="table-points border-1 px-2 py-1">
                                                        {key.slice(0, 1).toUpperCase() + key.slice(1).replace(/([a-z0-9])([A-Z])/g, '$1 $2')}
                                                    </td>
                                                    <td className="border-1 px-2 py-1">{value}</td>
                                                </tr>
                                            ))
                                    ) : (
                                        <tr>
                                            <td colSpan="2" className="text-center">
                                                No characteristics available.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
    )}
                        </div>)}

                    {/* product technical characteristics */}

                    {/* Product technical characteristics */}
                    {activeTab === 'technical' && (
                        <div className="product-characteristics mb-5 col-md-10">
                            <h1 className="CharcterHeading ">Technical Characteristics of Product</h1>
                            {isLoading ? (
      <div className="mt-3">
        <Skeleton height={40} className="mb-2" />
        <Skeleton height={40} className="mb-2" />
        <Skeleton height={40} className="mb-2" />
        <Skeleton height={40} className="mb-2" />
      </div>
    ) : (
                            <table className="table table-bordered mt-3">
                                <thead>
                                    <tr>
                                        <th className="table-head-points border-1 px-2 py-2">Characteristics</th>
                                        <th className="table-head border-1 px-2 py-2">Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {productDetail?.technicalAttributes &&
                                        Object.keys(productDetail.technicalAttributes).length > 0 ? (
                                        Object.entries(productDetail.technicalAttributes)
                                            .filter(([key]) => key !== 'technicalDescription') // Skip "technicalDescription"
                                            .map(([key, value], index) => (
                                                <tr key={index}>
                                                    <td className="table-points border-1 px-2 py-1">
                                                        {key
                                                            .slice(0, 1)
                                                            .toUpperCase() +
                                                            key
                                                                .slice(1)
                                                                .replace(/([a-z0-9])([A-Z])/g, '$1 $2')}
                                                    </td>
                                                    <td className="border-1 px-2 py-1">{value}</td>
                                                </tr>
                                            ))
                                    ) : (
                                        <tr>
                                            <td colSpan="2" className="text-center">
                                                No technical characteristics available.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
    )}
                        </div>
                    )}




                    {/* customer reviews */}

                    <div className="customer-reviews mb-5">
                        <div className="row">
                            {/* Left section: Customer reviews summary */}
                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <h5 className="mb-3">Customer reviews:</h5>
                                <div className="border rounded-4 p-2">
                                    <h6 className="">
                                        <span className="ms-2 text-warning">
                                            {"★".repeat(Math.round(averageRating))}{"☆".repeat(5 - Math.round(averageRating))}
                                        </span>
                                        {averageRating} out of 5
                                        <span className="text-muted">({reviews.length}) </span>
                                    </h6>

                                    <div className="mt-3">
                                        {[5, 4, 3, 2, 1].map((star, index) => (
                                            <div key={index} className="d-flex align-items-center mb-2 p-2">
                                                <span className="me-1">{star}</span>
                                                <span>Star</span>
                                                <div className="ms-1 progress w-100">
                                                    <div
                                                        className="progress-bar bg-warning"
                                                        role="progressbar"
                                                        style={{ width: `${star * 20}%` }}
                                                    ></div>
                                                </div>
                                                <span className="ms-2">
                                                    {reviews.filter((r) => r.rating === star).length}                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Review submission button */}
                                <div className="mt-5">
                                    <h6>Review this product:</h6>
                                    <p className="text-muted">Share your thoughts with other customers</p>
                                    <button className="py-2 px-3   w-100 rounded-pill btn"
                                        style={{
                                            //background: '#229EBD', 
                                            border: '1px solid #C1C1C1',
                                            color:'#303030',
                                            borderRadius: '10px'
                                        }}
                                        onClick={() => setShowModal(true)}>
                                        Write a review
                                    </button>

                                </div>
                                {/* Review Modal */}
                                <ReviewModal
                                    show={showModal}
                                    handleClose={() => setShowModal(false)}
                                    handleSubmit={handleReviewSubmit}
                                />
                            </div>

                            {/* Right section: Individual reviews */}
                            <div className="col-lg-8 col-md-8 col-12">
                                <h5>Reviews:</h5>
                                {isLoading ? (
  Array.from({ length: 3 }).map((_, idx) => (
    <div key={idx} className="card Review-card mb-3">
      <div className="card-body">
        <div className="d-flex align-items-start flex-wrap flex-column">
          <Skeleton width={100} height={20} className="mb-2" />
          <Skeleton width={150} height={15} className="mb-2" />
        </div>
        <Skeleton count={2} height={15} className="mb-2" />
        <Skeleton width={120} height={10} />
      </div>
    </div>
  ))
) : (
                                reviews.map((review, idx) => {
                                    // Ensure review.rating is within 1-5 range
                                    const rating = Math.min(Math.max(review.rating, 1), 5);

                                    return (
                                        <div key={idx} className="card Review-card mb-3">
                                            <div className="card-body">
                                                <div className="d-flex align-items-start flex-wrap flex-column">
                                                    <h6 className="review-name">
                                                        <span
                                                            className="rounded-circle p-2 me-2"
                                                            style={{ width: '32px', height: '32px', background: '#E9E8E8' }}
                                                        >
                                                            <Icon icon="codicon:account" className="fs-7" />
                                                        </span>
                                                        {review.createdBy}
                                                    </h6>
                                                    {/* Dynamically render stars */}
                                                    <span className="text-warning">
                                                        {Array.from({ length: 5 }).map((_, i) => (
                                                            <span key={i}
                                                                style={{ color: 'ffc107' }} className={i < rating ? "text-warning" : "ffc107"}>
                                                                {i < rating ? "★" : "☆"}
                                                            </span>
                                                        ))}
                                                        <span className="text-muted ms-2">{review.rating} Star</span>
                                                    </span>
                                                </div>
                                                <h6 className="mt-2">{review.comment}</h6>
                                                <small className="text-muted">Reviewed on {review.createdAt}</small>
                                            </div>
                                        </div>
                                    );
                                }))}




                            </div>
                        </div>
                    </div>


                </div>
            </div>


            {/* Modal */}
            {isModalOpen && (
                <div
                    className="modal-overlay"
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1000,
                    }}
                >
                    <div
                        className="modal-content"
                        style={{
                            background: 'white',
                            padding: '20px',
                            borderRadius: '8px',
                            maxWidth: '500px',
                            width: '100%',
                            textAlign: 'center',
                            position: 'relative', // For close icon positioning
                            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                        }}
                    >
                        {/* Close Icon */}
                        <div
                            onClick={handleCloseModal}
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '20px',
                                cursor: 'pointer',
                                fontSize: '18px',
                                color: '229EBD',
                            }}
                        >
                            <Icon icon="mingcute:close-fill" width="24" height="24" />
                        </div>

                        <h2 style={{ marginBottom: '10px' ,color:'#371300'}}>Get a Quote</h2>
                        <p>Fill a quote for this product.</p>
                        <form>


                            <div style={{ marginBottom: '10px' }}>
                                <textarea
                                    placeholder="Message"
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        borderRadius: '4px',
                                        border: '1px solid #ccc',
                                        height: '80px',
                                    }}
                                    value={enquiry.productEnquiryMsg}
                                    onChange={(e) => setEnquiry({ ...enquiry, productEnquiryMsg: e.target.value })}
                                />
                            </div>
                            <button
                                type="submit"
                                style={{
                                    background: isLoading ? '#ccc' : '#371300', // Disable styling
                                    color: 'white',
                                    padding: '10px 20px',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: isLoading ? 'not-allowed' : 'pointer',
                                }}
                                onClick={() => enquiryData()}
                                disabled={isLoading} // Disable button while loading
                            >
                                {isLoading ? 'Submitting...' : 'Submit'}
                            </button>




                        </form>
                    </div>
                </div>
            )}


            {/* <ToastContainer position="top-right" autoClose={3000} /> */}
            <ContactUs />
        </div>
    )
}

export default ProductDetailPage;
